export default __webpack_public_path__ + "static/media/Junge-auf-Trampolin.2c1a5613.png";